import { withDialogStackContext } from '@ui/core'
import type { WithDialogStackContext } from '@ui/core'

export type { WithDialogStackContext }
export default withDialogStackContext
